export default "__VITE_ASSET__BxsVS_J3__"